"use client"

import {CircularProgress, Icon, IconButton, Menu, MenuButton, MenuItem, MenuList} from "@chakra-ui/react";
import {useRouter} from "../../../i18n/routing";
import {useUser} from "../../tools/useUser";
import {useTranslations} from "next-intl";
import {DealParent, getContributeLink} from "../../../interfaces/IMomentDeal";
import {useEffect, useState} from "react";
import {markFresh} from "../../serverActions/markFresh";
import {CheckIcon, WarningIcon} from "@chakra-ui/icons";

export function ContributeMenu({dealOwner}: {dealOwner: DealParent}) {
    const [menuOpen, setMenuOpen] = useState(false)
    const [freshening, setFreshening] = useState<boolean>(false)
    useEffect(() => {
        const freshen = async () => {
            try {
                await markFresh(dealOwner)
                await new Promise(r => setTimeout(r, 2000));
                console.log("Done freshening")
                setMenuOpen(false)
            } catch (e) {
                console.log(e)
            } finally {
                setFreshening(false)
            }
        }
        if (freshening) freshen()
    }, [freshening, setFreshening]);

    const nav = useRouter()
    const editLink = getContributeLink(dealOwner)
    const user = useUser()
    const t = useTranslations("Home")

    return (
        <Menu isOpen={menuOpen} closeOnSelect={false} onOpen={() => setMenuOpen(true)} onClose={() => setMenuOpen(false)}>
            <MenuButton
                as={IconButton}
                icon={
                    <Icon viewBox="0 0 24 24" fill="currentColor">
                        <circle cx="12" cy="5" r="2" />
                        <circle cx="12" cy="12" r="2" />
                        <circle cx="12" cy="19" r="2" />
                    </Icon>
                }
                variant="icon"
                zIndex={10}
                boxSize="40px"
                borderRadius="full"
                aria-label="Options"
            />
            <MenuList>
                {editLink && (
                    <MenuItem icon={<WarningIcon/>} onClick={() => {
                        if (editLink) {
                            nav.push(editLink)
                        }
                    }}>{t("menu_report")}</MenuItem>
                )}

                {user?.moderator && (
                    <MenuItem icon={
                        <>
                            {freshening ? <CircularProgress isIndeterminate={true}/> : <CheckIcon/>}
                        </>
                    } onClick={() => setFreshening(true)} disabled={freshening}>{t("menu_mark_fresh")}</MenuItem>
                )}
            </MenuList>
        </Menu>
    )
}